export default "__VITE_ASSET__vQiJRex$__"